export const CREATION_CONSTANTS = {
    SUPER_COMPONENT: "SUPER_COMPONENT",
    MACHINE: "MACHINE",
    FLOW_TYPE: "FLOW_TYPE"
}